import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import '../../css/components/Launch/LaunchTopHeader.css';

function getCountdownStr(targetDate) {
  if (!targetDate) return '';
  const diff = new Date(targetDate) - new Date();
  if (diff <= 0) return '';
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const pad = (n) => String(n).padStart(2, '0');
  const h = pad(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  const m = pad(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
  const s = pad(Math.floor((diff % (1000 * 60)) / 1000));
  return `QUEDAN ${days} DÍAS Y ${h}:${m}:${s}`;
}

/**
 * Top header del landing.
 *
 * Estructura del ticker (de izquierda a derecha):
 *   [title]  [linkText →link al landing]  [countdown]  [description]
 *
 * - title       → texto estático, NO clickeable (ej: "PRONTO")
 * - linkText    → texto clickeable que linkea al landing (ej: "DON JULIO 1942 ...")
 * - countdown   → se inserta automáticamente si countdownTargetDate está seteado
 * - description → texto final del ticker
 *
 * Fallback retrocompatible: si no llega linkText pero sí title, partimos title
 * por el primer espacio (comportamiento anterior). Esto mantiene funcionando
 * campañas viejas hasta que el admin las migre al esquema nuevo.
 */
function LaunchTopHeader({
  title,
  description,
  linkText,
  startColor,
  endColor,
  countdownTargetDate,
  campaignSlug,
}) {
  const [countdownStr, setCountdownStr] = useState('');
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    if (!countdownTargetDate) return;

    const updateCountdown = () => setCountdownStr(getCountdownStr(countdownTargetDate));
    updateCountdown();

    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, [countdownTargetDate]);

  if (!isClient) return null;

  const background =
    startColor && endColor
      ? `linear-gradient(90deg, ${startColor}, ${endColor})`
      : '#00271a';

  // Resolución del texto a renderizar:
  // - Si tenemos linkText explícito → tag=title, link=linkText.
  // - Si NO tenemos linkText pero sí title → fallback al split anterior por
  //   compatibilidad con campañas viejas.
  let tag = '';
  let link = '';
  if (linkText) {
    tag = (title || '').trim();
    link = linkText.trim();
  } else if (title) {
    const trimmed = String(title).trim();
    const idx = trimmed.indexOf(' ');
    if (idx === -1) {
      link = trimmed;
    } else {
      tag = trimmed.slice(0, idx);
      link = trimmed.slice(idx + 1).trim();
    }
  }

  return (
    <div className="LaunchTopHeader" style={{ background }}>
      <div className="LaunchTopHeader__inner">
        {tag && <span className="LaunchTopHeader__tag">{tag}</span>}
        {link && (
          campaignSlug ? (
            <Link to={`/lanzamiento/${campaignSlug}/`} className="LaunchTopHeader__highlight">
              {link}
            </Link>
          ) : (
            <span className="LaunchTopHeader__highlight">{link}</span>
          )
        )}
        {countdownStr && <span className="LaunchTopHeader__countdown">{countdownStr}</span>}
        {description && <span className="LaunchTopHeader__desc">{description}</span>}
      </div>
    </div>
  );
}

export default LaunchTopHeader;
